/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { getRandomVehicleColor, getColor, ColorObject } from 'jotai/vehicleColor';

export interface ManufacturerObject extends ColorObject {
  manufacturer: string;
}

const oemColors: ReadonlyArray<ManufacturerObject> = [
  {
    ...(getColor('26', 'vehicle') as ColorObject),
    manufacturer: 'Chevrolet',
  },
  {
    ...(getColor('5', 'vehicle') as ColorObject),
    manufacturer: 'Ford',
  },
  {
    ...(getColor('17', 'vehicle') as ColorObject),
    manufacturer: 'Toyota',
  },
  {
    ...(getColor('10', 'vehicle') as ColorObject),
    manufacturer: 'Honda',
  }
];

export const getOemColor = (manufacturer: string) => {
  const oemObject = oemColors.find((oem) => oem.manufacturer === manufacturer);
  if (oemObject) {
    return oemObject;
  } else {
    const randomColor = getRandomVehicleColor();
    return {
      ...randomColor,
      manufacturer: manufacturer,
    } as ManufacturerObject;
  }
};
